import React from 'react';
import styles from './ProfilePageSkeleton.module.css';

const ProfilePageSkeleton: React.FC = () => {
  return (
    <div className={styles.skeletonContainer}>
      <div className={styles.coverImageSkeleton}></div>
      
      <div className={styles.profileInfo}>
        <div className={styles.userHeader}>
          <div className={styles.avatarSkeleton}></div>
          
          <div className={styles.userDetails}>
            <div className={styles.userNameSkeleton}></div>
            <div className={styles.userBioSkeleton}></div>
          </div>
        </div>
        
        <div className={styles.userStats}>
          {[1, 2, 3].map((i) => (
            <div key={i} className={styles.statItemSkeleton}>
              <div className={styles.statValueSkeleton}></div>
              <div className={styles.statLabelSkeleton}></div>
            </div>
          ))}
        </div>
      </div>
      
      <div className={styles.sitesScrollSkeleton}>
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className={styles.siteItemSkeleton}></div>
        ))}
      </div>
      
      <div className={styles.gridSkeleton}>
        {[...Array(9)].map((_, index) => (
          <div key={index} className={styles.gridItemSkeleton}></div>
        ))}
      </div>
    </div>
  );
};

export default ProfilePageSkeleton;
